const pageOverlayActiveClass = 'body--showOverlayFull';
const overlayActiveClass = 'consultantOverlay--active';

let overlayButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-consultantOverlay');
let overlays: NodeListOf<HTMLElement> = document.querySelectorAll('.js-overlay');

export function ConsultantController() {
  let overlayClose: NodeListOf<HTMLElement> = document.querySelectorAll('.js-overlayClose');

  overlayButtons.forEach((overlayButton) => {
    overlayButton.addEventListener('click', (event: Event) => {
      const consultantData = overlayButton.dataset.targetOverlay;
      if (!consultantData) {
        return;
      }
      const consultantDataId = parseInt(consultantData, 10);
      overlays.forEach((overlay, index) => {
        if (index === consultantDataId) {
          overlayButton.classList.add(overlayActiveClass);
          document.body.classList.add(pageOverlayActiveClass);
          overlay.classList.remove('hide');
        }
      });
    });
  });

  if (overlayClose) {
    overlayClose.forEach((close) => {
      close.addEventListener('click', (event: Event) => {
        closeOverlay();
        closePageOverlay();
      });
    });
  }

  /* close navigation on escape key or click on page overlay */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOverlay();
      closePageOverlay();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.classList.contains(pageOverlayActiveClass)) {
      closeOverlay();
      closePageOverlay();
    }
  });
}

function closePageOverlay() {
  document.body.classList.remove(pageOverlayActiveClass);
}

function closeOverlay() {
  overlays.forEach((overlay) => {
    overlay.classList.remove(overlayActiveClass);
    overlay?.classList.add('hide');
  });
}
